import React, {
  MutableRefObject,
  RefObject,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import * as _ from 'lodash';
import {
  Button,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Row,
  Select,
} from 'antd';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow-down-icon.svg';
import { ReactComponent as CalendarIcon } from 'app/assets/img/calendar-icon.svg';
import { LoadingOutlined, DownOutlined } from '@ant-design/icons';

import StyledButton from 'app/components/StyledButton';
import useWindowSize from 'app/hooks/useWindowSize';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import StyledDatePicker from 'app/pages/NewAccount/components/StyledDatePicker';
import StyledSearchInput from 'app/pages/NewAccount/components/StyledSearchInput';
import StyledSelect, {
  MobileStyledSelect,
} from 'app/pages/NewAccount/components/StyledSelect';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { I_Agents } from 'app/pages/NewAccount/CheckTickets/slice/types';
import {
  getDataAgentApi,
  getDataSelectTicketApi,
} from 'app/services/checkTicketApi';
import styled from 'styled-components';
import { StyleCustome, StyledPopover } from './styled';
import { CustomPopoverContent } from 'app/pages/Catalog/components/helper';
import { convertVItoEN, listObject, listType } from './helper';
import RangeDatePicker from 'app/components/FormInput/RangeDatePicker';
import RangeDatePickerCustom from './RangeDatePickerCustom';
import { objectType } from 'types';
import { getDayOfWeekString } from 'utils/time';
import { BP_TYPE } from 'utils/constants';
import useAllocatedDebt from 'app/hooks/useAllocatedDebt';
import { Permission } from 'app/hooks/usePermission';
import { ORDER_SOURCE_OPTIONS } from '../PurchaseHistory';
type SearchComponentProps = {
  travelLocation: {
    value: string;
    label: string;
  }[];
  onSubmitSearh: (params: any) => void;
  filters?: any;
  listStatus?: any;
  listOrderTypeStr?: any;
  listZone?: any;
  listPerformance?: any;
  listRestaurant?: any;
  listGroupCode: { label: string; value: string }[];
  ticketTypeOptions?: any;
};

export const formatDate = (
  date: moment.Moment,
  translation: objectType | undefined,
) => {
  const dayOfWeek = getDayOfWeekString(date, translation);
  // Format the rest of the date
  return `${dayOfWeek} ${date.format('(DD/MM/YYYY)')}`;
};

export const DesktopSearchComponent = ({
  onSubmitSearh,
  filters,
  travelLocation,
  listStatus,
  listOrderTypeStr,
  listZone,
  listPerformance,
  listRestaurant,
  listGroupCode,
  ticketTypeOptions,
}: SearchComponentProps) => {
  const translations = useSelector(selectTranslations);
  const userInfo = useSelector(selectInfoUser);
  const [dataAgent, setDataAgent] = useState<any[]>([]);
  const [dataProduct, setDataProduct] = useState<any[]>([]);
  const [paramsSearch, setParamsSearch] = useState(filters);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [valueType, setValueType] = useState<any>(filters?.areaType || []);
  const [valueObject, setValueObject] = useState<any>(filters?.ageType || []);

  const isProxyBuyer =
    (userInfo?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;

  const [allocatedSearch, setAllocatedSearch] = useState('');

  const { result: allocatedDebtData } = useAllocatedDebt({
    IIFE: isProxyBuyer,
    search: allocatedSearch,
  });

  const initParamProducts: any = { limit: 50, page: 1, search: '', last: null };
  const paramsProducts = useRef(initParamProducts);

  const containerRef = useRef<HTMLDivElement>(null);
  const [filterItemWith, setFilterItemWidth] = useState({
    small: 0,
    normal: 0,
  });
  useLayoutEffect(() => {
    const getFilterItemWidth = () => {
      const containerWidth = Math.floor(
        containerRef.current!.getBoundingClientRect().width,
      );
      setFilterItemWidth({
        small: (containerWidth! - 5 * 12 - 120) / 5,
        normal: (containerWidth! - 3 * 12) / 4,
      });
    };

    getFilterItemWidth();
    window.addEventListener('resize', getFilterItemWidth);
    return () => {
      window.removeEventListener('resize', getFilterItemWidth);
    };
  }, []);

  useEffect(() => {
    setParamsSearch(filters);
  }, [filters]);

  const isSaleMng =
    userInfo?.role_code === Permission.ROLE_SALE_MANAGER ||
    userInfo?.role_code === Permission.ROLE_SALE_SHG;

  const getDataAgent = async () => {
    try {
      const { data } = await getDataAgentApi();
      if (!_.isEmpty(data?.data)) {
        const resAgents = data?.data.map((item: any) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
        setDataAgent(
          isSaleMng
            ? [
                {
                  id: 0,
                  label: translations ? translations['b2b.text.all'] : '',
                  value: 'All',
                },
                ...resAgents,
              ]
            : resAgents,
        );
      }
    } catch (error) {}
  };
  const getDataProduct = async (params: I_Agents) => {
    setLoadingProducts(true);
    try {
      if (paramsProducts.current.page > +(params.page as number)) {
        setLoadingProducts(false);
        return;
      }
      const { data } = await getDataSelectTicketApi(params);
      if (data?.paginator) {
        paramsProducts.current = {
          ...paramsProducts.current,
          last: +data?.paginator.last,
          page: +data?.paginator.current,
        };
      }
      const resProducts = _.isEmpty(data?.data)
        ? []
        : data?.data.map((item: any) => {
            return {
              label: item.name || item.id,
              value: item.id,
            };
          });
      setDataProduct([...dataProduct, ...resProducts]);
    } catch (error) {
    } finally {
      setLoadingProducts(false);
    }
  };
  const handleSearchProduct = async paramsSearch => {
    if (!_.isEmpty(paramsSearch)) {
      setLoadingProducts(true);
    }
    try {
      const { data } = await getDataSelectTicketApi({
        limit: paramsProducts.current.limit,
        search: paramsSearch,
        page: 1,
      });
      if (data?.paginator) {
        paramsProducts.current = {
          ...paramsProducts.current,
          last: +data?.paginator.last,
          page: +data?.paginator.current,
        };
      }
      const resProducts = _.isEmpty(data?.data)
        ? []
        : data?.data.map((item: any) => {
            return {
              label: item.name || item.id,
              value: item.id,
            };
          });
      setDataProduct(resProducts);
    } catch (error) {
    } finally {
      setLoadingProducts(false);
    }
  };
  const handleScroll = e => {
    const isEndOfList = e.target.scrollTop > (4 / 5) * e.target.scrollHeight;
    const endLoading =
      _.isNumber(paramsProducts.current.last) &&
      paramsProducts.current.page + 1 > +paramsProducts.current.last;

    if (isEndOfList && !endLoading) {
      getDataProduct({
        ...paramsProducts.current,
        page: paramsProducts.current.page + 1,
      });
    }
  };

  const onChangeType = (valueType: any) => {
    setParamsSearch({
      ...paramsSearch,
      areaType: valueType,
    });
    setValueType(valueType);
  };
  const onChangeObject = (valueAge: any) => {
    setParamsSearch({
      ...paramsSearch,
      ageType: valueAge,
    });
    setValueObject(valueAge);
  };

  const submitFilter = () => {
    const submitData = Object.keys(paramsSearch)
      .filter(key => !_.isNil(paramsSearch[key]))
      .reduce(
        (s, a) => ({
          ...s,
          [a]: paramsSearch[a],
        }),
        {},
      );
    onSubmitSearh(submitData);
  };
  const getValueTypeFilter = () => {
    let text = '';
    const arrObject = listObject(translations).filter(item =>
      valueObject.includes(item.value),
    );
    const arrType = listType(translations).filter(item =>
      valueType.includes(item.value),
    );
    const arrGroup: any = [...arrObject, ...arrType];
    const textGroup = arrGroup.map((i: any) => i?.label);
    text = textGroup.toString();
    return text;
  };
  useEffect(() => {
    if (translations) {
      getDataAgent();
      getDataProduct(initParamProducts);
    }
  }, [translations]);

  return (
    <Form>
      <StyleCustome ref={containerRef}>
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <div style={{ minWidth: 'fit-content' }}>
            {translations?.['b2b.txt.validFromDate']}
          </div>
          <RangeDatePickerContainer style={{ width: '100%' }}>
            <RangeDatePickerCustom
              placeholder={
                translations ? translations['b2b.txt.ticket-expried'] : ''
              }
              startDateInit={new Date(paramsSearch?.expiredDateFrom)}
              endDateInit={new Date(paramsSearch?.expiredDateTo)}
              syncFromProps
              // onChange={value => {
              //   const [startDate, endDate] = value;
              //   setParamsSearch({
              //     ...paramsSearch,
              //     expiredDateFrom: startDate
              //       ? moment(startDate).format('YYYY-MM-DD')
              //       : '',
              //     expiredDateTo:
              //       !startDate && !endDate
              //         ? ''
              //         : moment(endDate ?? startDate).format('YYYY-MM-DD'),
              //   });
              // }}
              onChange={value => {
                const [startDate, endDate] = value;
                if (!startDate) {
                  setParamsSearch({
                    ...paramsSearch,
                    expiredDateFrom: '',
                    expiredDateTo: '',
                  });
                  return;
                }
                let finalEndDate = endDate ?? startDate;
                const maxEndDate = moment(startDate).add(30, 'days').toDate();
                if (finalEndDate > maxEndDate) {
                  finalEndDate = maxEndDate;
                }
                setParamsSearch({
                  ...paramsSearch,
                  expiredDateFrom: moment(startDate).format('YYYY-MM-DD'),
                  expiredDateTo: moment(finalEndDate).format('YYYY-MM-DD'),
                });
              }}
              minDate={null}
            />
          </RangeDatePickerContainer>
        </div>
        {/* <PopupContainer ref={popupDatePicker} /> */}
        <StyledDatePicker
          style={{ width: filterItemWith.normal }}
          // className="date-picker"
          suffixIcon={<CalendarIcon />}
          placeholder={translations ? translations['b2b.txt.used-date'] : ''}
          format={date => formatDate(date, translations)}
          inputReadOnly={false}
          // getPopupContainer={() => popupDatePicker.current!}
          // value={paramsSearch.orderDate ? moment(paramsSearch.orderDate) : null}
          onChange={(e: any) => {
            setParamsSearch({
              ...paramsSearch,
              orderDate: moment(e)?.isValid()
                ? moment(e).format('YYYY-MM-DD')
                : '',
            });
          }}
          allowClear
          minWidthInput="auto"
        />
        {/* <PopupContainer ref={parkPicker} /> */}
        <StyledSelect
          filterOption={(input, option) =>
            (convertVItoEN(option?.label) ?? '').includes(convertVItoEN(input))
          }
          showSearch
          isFocus
          value={paramsSearch.park}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2c.txt.park'] : ''}
          onChange={val =>
            setParamsSearch({
              ...paramsSearch,
              park: val,
            })
          }
          options={travelLocation}
          style={{ width: filterItemWith.normal }}
          // getPopupContainer={() => parkPicker.current!}
        />
        <StyledSearchInput
          placeholder={
            translations
              ? translations['b2b.txt.search-place-holder-check-tickets']
              : ''
          }
          onBlur={e => {
            setParamsSearch({
              ...paramsSearch,
              searchOrderId: e?.target?.value?.trim(),
            });
          }}
          onChange={e =>
            setParamsSearch({
              ...paramsSearch,
              searchOrderId: e?.target?.value,
            })
          }
          value={paramsSearch.searchOrderId}
          width={`${filterItemWith.normal}px`}
        />
        {/* <PopupContainer ref={orderTypeStrPicker} /> */}
        <StyledSelect
          filterOption={(input, option) =>
            (convertVItoEN(option?.label) ?? '').includes(convertVItoEN(input))
          }
          showSearch
          isFocus
          value={paramsSearch.orderTypeStr}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2b.txt.order-type'] : ''}
          onChange={val =>
            setParamsSearch({ ...paramsSearch, orderTypeStr: val })
          }
          options={listOrderTypeStr}
          allowClear
          style={{ width: filterItemWith.normal }}
          // getPopupContainer={() => agentPicker.current!}
        />

        {/* <PopupContainer ref={agentPicker} /> */}
        <StyledSelect
          filterOption={(input, option) =>
            (convertVItoEN(option?.label) ?? '').includes(convertVItoEN(input))
          }
          showSearch
          isFocus
          value={paramsSearch.status}
          suffixIcon={<ArrowDownIcon />}
          placeholder={
            translations ? translations['b2b.txt.ticket-status'] : ''
          }
          onChange={val => setParamsSearch({ ...paramsSearch, status: val })}
          options={listStatus}
          allowClear
          // getPopupContainer={() => agentPicker.current!}
          style={{ width: filterItemWith.normal }}
        />
        {/* <PopupContainer ref={popupDatePicker} /> */}

        {/* <PopupContainer ref={parkPicker} /> */}
        {/* <PopupContainer ref={productPicker} /> */}
        <StyledSelect
          value={paramsSearch.product_id}
          suffixIcon={
            loadingProducts ? (
              <LoadingOutlined
                style={{
                  fontSize: 20,
                  color: '#1890ff',
                }}
              />
            ) : (
              <ArrowDownIcon />
            )
          }
          isFocus
          placeholder={translations ? translations['b2b.booking.products'] : ''}
          onChange={val =>
            setParamsSearch({
              ...paramsSearch,
              product_id: val,
            })
          }
          // height={'44px'}
          maxTagCount={'responsive'}
          mode="multiple"
          allowClear
          onBlur={() => {
            handleSearchProduct('');
          }}
          onSearch={_.debounce(handleSearchProduct, 300)}
          options={dataProduct}
          // lineHeight="39px"
          filterOption={false}
          loading={loadingProducts}
          onPopupScroll={_.debounce(handleScroll, 150)}
          // getPopupContainer={() => productPicker.current!}
          onClear={() => {
            handleSearchProduct('');
          }}
          style={{ width: filterItemWith.normal }}
        />
        {/* <PopupContainer ref={agentPicker} /> */}
        <StyledSelect
          filterOption={(input, option) =>
            (convertVItoEN(option?.label) ?? '').includes(convertVItoEN(input))
          }
          showSearch
          isFocus
          value={paramsSearch.agent}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2b.txt.orderer'] : ''}
          onChange={val => setParamsSearch({ ...paramsSearch, agent: val })}
          options={dataAgent}
          allowClear
          // getPopupContainer={() => agentPicker.current!}
          style={{ width: filterItemWith.normal }}
        />
        {/* {/* <PopupContainer ref={zonePicker} /> */}
        {/* <StyledSelect
          value={paramsSearch.zoneId}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2b.txt.zone'] : ''}
          onChange={val => setParamsSearch({ ...paramsSearch, zoneId: val })}
          options={listZone}
          allowClear
          className="dropdown-select-zone"
          getPopupContainer={() => zonePicker.current!}
        /> */}
        {/* <PopupContainer ref={zonePicker} /> */}
        <StyledSelect
          filterOption={(input, option) =>
            (convertVItoEN(option?.label) ?? '').includes(convertVItoEN(input))
          }
          showSearch
          isFocus
          value={paramsSearch.restaurantId}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2c.text.restaurants'] : ''}
          onChange={val =>
            setParamsSearch({ ...paramsSearch, restaurantId: val })
          }
          options={listRestaurant}
          allowClear
          style={{
            width: isProxyBuyer ? filterItemWith.normal : filterItemWith.normal,
          }}
          // getPopupContainer={() => zonePicker.current!}
        />
        <StyledSelect
          value={paramsSearch.groupCode}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2b.txt.group-code'] : ''}
          onChange={val => setParamsSearch({ ...paramsSearch, groupCode: val })}
          options={listGroupCode}
          style={{
            width: isProxyBuyer ? filterItemWith.normal : filterItemWith.small,
          }}
          allowClear
        />
        {/* <PopupContainer ref={performancePicker} /> */}
        <StyledSelect
          filterOption={(input, option) =>
            (convertVItoEN(option?.label) ?? '').includes(convertVItoEN(input))
          }
          showSearch
          isFocus
          value={paramsSearch.performanceTime}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2b.txt.hours'] : ''}
          onChange={val =>
            setParamsSearch({ ...paramsSearch, performanceTime: val })
          }
          options={listPerformance}
          allowClear
          style={{
            width: isProxyBuyer ? filterItemWith.normal : filterItemWith.small,
          }}
          // getPopupContainer={() => performancePicker.current!}
        />
        {/* <PopupContainer ref={ticketStatusPicker} /> */}
        {/* <PopupContainer ref={filterPicker} /> */}
        <StyledPopover
          placement="bottomLeft"
          content={CustomPopoverContent(
            valueType,
            onChangeType,
            valueObject,
            onChangeObject,
            listType(translations),
            listObject(translations),
          )}
          trigger="click"
          overlayInnerStyle={{
            borderRadius: '10px',
          }}
          zIndex={1}
          // getPopupContainer={() => filterPicker.current!}
        >
          <Button
            className="dropdown-filter"
            style={{
              width: isProxyBuyer
                ? filterItemWith.normal
                : filterItemWith.small,
            }}
          >
            <Input
              className="input-filter"
              value={getValueTypeFilter()}
              readOnly
              placeholder={translations ? translations['b2c.txt.filter'] : ''}
            />
            <img
              alt="icon_filter"
              src="/static/img/icon_filter.svg"
              style={{
                filter: 'contrast(0)',
              }}
            />
          </Button>
        </StyledPopover>

        <StyledSelect
          value={paramsSearch.type}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2b.txt.ticket-type'] : ''}
          onChange={val => setParamsSearch({ ...paramsSearch, type: val })}
          options={ticketTypeOptions}
          style={{
            width: isProxyBuyer ? filterItemWith.normal : filterItemWith.small,
          }}
          allowClear
          mode="tags"
          maxTagCount={1}
        />

        {isProxyBuyer && (
          <StyledSelect
            filterOption={false}
            onSearch={value => {
              setAllocatedSearch(value);
            }}
            showSearch
            isFocus
            value={paramsSearch?.bpAllocatedDebt}
            suffixIcon={<ArrowDownIcon />}
            placeholder={translations ? translations['b2b.txt.authorized'] : ''}
            onChange={val => {
              setAllocatedSearch('');
              setParamsSearch({
                ...paramsSearch,
                bpAllocatedDebt: val,
              });
            }}
            options={allocatedDebtData?.map(i => ({
              value: i?.id,
              label: i?.name,
            }))}
            allowClear
            style={{ width: filterItemWith.normal }}
          />
        )}

        {/* <PopupContainer ref={groupCodePicker} /> */}

        {!isProxyBuyer && (
          <StyledSelect
            filterOption={(input, option) =>
              (convertVItoEN(option?.label) ?? '').includes(
                convertVItoEN(input),
              )
            }
            showSearch
            isFocus
            value={paramsSearch?.orderSource}
            suffixIcon={<ArrowDownIcon />}
            placeholder={translations ? translations['b2b.txt.source'] : ''}
            onChange={val =>
              setParamsSearch({ ...paramsSearch, orderSource: val })
            }
            options={ORDER_SOURCE_OPTIONS.map(i => ({
              value: i.value,
              label: translations?.[i.labelKey] ?? '',
            }))}
            allowClear
            style={{
              width: 120,
            }}
          />
        )}

        <StyledButton
          onClick={() => submitFilter()}
          style={{
            background: '#FFFFFF',
            border: '1px solid #F8B117',
            color: '#F8B117',
            // margin: 5,
            // marginRight: 20,
            width: 124,
            maxWidth: 124,
            height: 44,
            flex: 1,
          }}
        >
          {translations ? translations['b2c.txt.search'] : ''}
        </StyledButton>
      </StyleCustome>
    </Form>
  );
};

const PopupContainer = styled.div`
  display: inline-block;
  & > div:first-child {
    z-index: 1;
  }
`;

const RangeDatePickerContainer = styled.div`
  height: 44px;
  display: inline-block;
  .react-datepicker__close-icon {
    right: 5px;
  }
`;
